<template>
  <section id="pp-experience" class="pp-section">
    <h2 class="pp-section__title">
      <i class="mdi mdi-briefcase" aria-hidden="true"></i> Experience
      <span v-if="experienceLabel" class="pp-pill pp-pill--muted" style="font-size:0.72rem;margin-left:auto;">{{ experienceLabel }}</span>
    </h2>

    <div v-if="hasExperience" class="pp-timeline">
      <div
        v-if="currentCompany"
        class="pp-timeline__item"
      >
        <div class="pp-timeline__marker">
          <span class="pp-timeline__dot"></span>
          <span v-if="previousCompanies.length" class="pp-timeline__line"></span>
        </div>
        <div class="pp-timeline__card pp-timeline__card--current">
          <span class="pp-timeline__badge">Current</span>
          <p class="pp-timeline__company">{{ currentCompany.worked_company_name }}</p>
          <p class="pp-timeline__role">{{ currentCompany.designation }}</p>
          <p class="pp-timeline__dates">{{ currentDates }}</p>
          <div v-if="currentSkills.length" class="pp-pills">
            <span v-for="s in currentSkills" :key="s" class="pp-pill pp-pill--muted">{{ s }}</span>
          </div>
        </div>
      </div>

      <div
        v-for="(company, index) in previousCompanies"
        :key="'prev-' + index"
        class="pp-timeline__item"
      >
        <div class="pp-timeline__marker">
          <span class="pp-timeline__dot"></span>
          <span v-if="index < previousCompanies.length - 1" class="pp-timeline__line"></span>
        </div>
        <div class="pp-timeline__card">
          <p class="pp-timeline__company">{{ company.worked_company_name }}</p>
          <p class="pp-timeline__role">{{ company.designation }}</p>
          <p class="pp-timeline__dates">{{ formatRange(company) }}</p>
          <div v-if="parseSkillList(company.skills).length" class="pp-pills">
            <span v-for="s in parseSkillList(company.skills)" :key="s" class="pp-pill pp-pill--muted">{{ s }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { formatWorkRange } from '@/utils/publicProfile';

export default {
  name: 'PublicProfileExperience',
  props: {
    currentCompany: { type: Object, default: null },
    previousCompanies: { type: Array, default: () => [] },
    experienceLabel: { type: String, default: '' },
  },
  computed: {
    hasExperience() {
      return this.currentCompany || this.previousCompanies.length;
    },
    currentDates() {
      if (!this.currentCompany) return '';
      return formatWorkRange(
        this.currentCompany.work_duration_month_from,
        this.currentCompany.work_duration_year_from,
        null,
        null,
        true,
      );
    },
    currentSkills() {
      return this.parseSkillList(this.currentCompany?.skills);
    },
  },
  methods: {
    formatRange(company) {
      return formatWorkRange(
        company.work_duration_month_from,
        company.work_duration_year_from,
        company.work_duration_month_to,
        company.work_duration_year_to,
        false,
      );
    },
    parseSkillList(raw) {
      if (!raw) return [];
      if (Array.isArray(raw)) return raw;
      return String(raw).split(',').map((s) => s.trim()).filter(Boolean);
    },
  },
};
</script>
